import { render, staticRenderFns } from "./ChatCorrespondenceMessage.vue?vue&type=template&id=97ca2400&scoped=true&"
import script from "./ChatCorrespondenceMessage.vue?vue&type=script&lang=js&"
export * from "./ChatCorrespondenceMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChatCorrespondenceMessage.vue?vue&type=style&index=0&id=97ca2400&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ca2400",
  null
  
)

export default component.exports